import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

type Props = {
  testId?: string;
  onDragEnd: (any) => void;
  items: any[];
  enabled: boolean;
  children: (item: any, index: number) => React.FC<any>;
};

export const DragDrop: React.FC<Props> = ({ testId, onDragEnd, items, enabled, children }) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId={'droppable'}>
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {items.map((item, i) => (
              <Draggable
                key={`${item.id}`}
                data-test-id={testId}
                draggableId={`${item.id}`}
                index={i}
                isDragDisabled={!enabled}
              >
                {(provided, snapshot) => (
                  <div
                    data-testid={testId}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={{
                      ...provided.draggableProps.style,
                      opacity: snapshot.isDragging ? 0.5 : 1,
                    }}
                  >
                    {children(item, i)}
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};
